module.exports = __webpack_public_path__ + "static/img/Adam-Reynolds.f88636a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-Reynolds.jpg
// module id = Kyum
// module chunks = 0